export default function Article5() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-emerald-50 to-teal-50">
      {/* Header */}
      <header className="bg-white shadow-sm sticky top-0 z-50">
        <div className="container mx-auto px-6 py-4">
          <div className="flex items-center justify-between">
            <a href="/" className="flex items-center space-x-3 cursor-pointer">
              <img 
                src="https://static.readdy.ai/image/594dc4849304cbd3bd7a23edd8bf4d32/085c019ea1217b73a4a5e1e39cd86a89.jpeg"
                alt="PROTECPLUS INGENIERÍA"
                className="h-16 w-auto"
              />
            </a>
            <div className="flex gap-4">
              <a 
                href="/blog"
                className="text-emerald-600 hover:text-emerald-700 font-semibold transition-colors cursor-pointer"
              >
                <i className="ri-arrow-left-line mr-2"></i>
                Volver al Blog
              </a>
              <a 
                href="/"
                className="text-emerald-600 hover:text-emerald-700 font-semibold transition-colors cursor-pointer"
              >
                <i className="ri-home-line mr-2"></i>
                Inicio
              </a>
            </div>
          </div>
        </div>
      </header>

      {/* Article Content */}
      <article className="container mx-auto px-6 py-12 max-w-4xl">
        {/* Article Header */}
        <div className="mb-8">
          <div className="flex items-center space-x-4 text-sm text-gray-500 mb-4">
            <span className="bg-emerald-100 text-emerald-700 px-3 py-1 rounded-full font-medium">
              Novedades
            </span>
            <span className="flex items-center space-x-1">
              <i className="ri-calendar-line"></i>
              <span>20 Diciembre 2024</span>
            </span>
            <span className="flex items-center space-x-1">
              <i className="ri-time-line"></i>
              <span>7 min lectura</span>
            </span>
          </div>
          
          <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            BIM en Proyectos de Protección contra Incendios
          </h1>
          
          <div className="w-full h-96 rounded-2xl overflow-hidden mb-8">
            <img 
              src="https://public.readdy.ai/ai/img_res/ae2c2edd98b08427b4e18880f5a1900d.jpg"
              alt="BIM en Proyectos de Protección contra Incendios"
              className="w-full h-full object-cover"
            />
          </div>
        </div>

        {/* Article Body */}
        <div className="prose prose-lg max-w-none">
          <div className="bg-emerald-50 border-l-4 border-emerald-500 p-6 rounded-r-lg mb-8">
            <p className="text-gray-700 font-medium">
              La metodología BIM (Building Information Modeling) está transformando el diseño, instalación y mantenimiento de sistemas de protección contra incendios, mejorando la eficiencia y reduciendo errores.
            </p>
          </div>

          <h2 className="text-3xl font-bold text-gray-900 mt-12 mb-6">¿Qué es BIM?</h2>
          <p className="text-gray-700 leading-relaxed mb-4">
            BIM es una metodología de trabajo colaborativa que permite crear y gestionar información de un proyecto de construcción en formato digital durante todo su ciclo de vida.
          </p>
          <ul className="list-disc pl-6 mb-6 text-gray-700 space-y-2">
            <li>Modelo 3D inteligente con información asociada</li>
            <li>Colaboración en tiempo real entre todos los agentes</li>
            <li>Detección automática de interferencias</li>
            <li>Gestión integral desde diseño hasta mantenimiento</li>
          </ul>

          <h2 className="text-3xl font-bold text-gray-900 mt-12 mb-6">Ventajas de BIM en Protección contra Incendios</h2>
          
          <h3 className="text-2xl font-semibold text-gray-800 mt-8 mb-4">1. Diseño y Planificación</h3>
          <div className="bg-white border border-gray-200 rounded-xl p-6 mb-8">
            <ul className="text-gray-700 space-y-3">
              <li className="flex items-start space-x-3">
                <i className="ri-check-line text-emerald-600 text-xl mt-0.5"></i>
                <span><strong>Visualización 3D:</strong> Representación realista de todos los sistemas de protección</span>
              </li>
              <li className="flex items-start space-x-3">
                <i className="ri-check-line text-emerald-600 text-xl mt-0.5"></i>
                <span><strong>Cálculos automáticos:</strong> Dimensionamiento de redes, caudales y presiones</span>
              </li>
              <li className="flex items-start space-x-3">
                <i className="ri-check-line text-emerald-600 text-xl mt-0.5"></i>
                <span><strong>Simulaciones:</strong> Análisis de evacuación y propagación de humos</span>
              </li>
              <li className="flex items-start space-x-3">
                <i className="ri-check-line text-emerald-600 text-xl mt-0.5"></i>
                <span><strong>Cumplimiento normativo:</strong> Verificación automática de requisitos</span>
              </li>
            </ul>
          </div>

          <h3 className="text-2xl font-semibold text-gray-800 mt-8 mb-4">2. Coordinación entre Disciplinas</h3>
          <p className="text-gray-700 leading-relaxed mb-4">
            BIM facilita la coordinación entre diferentes especialidades:
          </p>
          <ul className="list-disc pl-6 mb-6 text-gray-700 space-y-2">
            <li><strong>Arquitectura:</strong> Integración de sectores de incendio y vías de evacuación</li>
            <li><strong>Estructura:</strong> Verificación de resistencia al fuego de elementos</li>
            <li><strong>Instalaciones:</strong> Coordinación con climatización, electricidad y fontanería</li>
            <li><strong>Detección de colisiones:</strong> Identificación automática de interferencias</li>
          </ul>

          <h3 className="text-2xl font-semibold text-gray-800 mt-8 mb-4">3. Ejecución de Obra</h3>
          <p className="text-gray-700 leading-relaxed mb-4">
            Durante la fase de construcción, BIM aporta:
          </p>
          <ul className="list-disc pl-6 mb-6 text-gray-700 space-y-2">
            <li>Planos de instalación precisos y actualizados</li>
            <li>Mediciones automáticas para presupuestos</li>
            <li>Planificación temporal de instalaciones</li>
            <li>Control de calidad y seguimiento de obra</li>
          </ul>

          <h2 className="text-3xl font-bold text-gray-900 mt-12 mb-6">Aplicaciones Específicas en PCI</h2>
          
          <div className="space-y-6 mb-8">
            <div className="bg-white border border-gray-200 rounded-xl p-6">
              <h4 className="font-semibold text-gray-900 mb-3 flex items-center space-x-2">
                <i className="ri-water-flash-line text-emerald-600 text-xl"></i>
                <span>Sistemas de Rociadores</span>
              </h4>
              <ul className="text-gray-700 space-y-2 text-sm">
                <li>• Diseño automático de red de tuberías</li>
                <li>• Cálculo hidráulico integrado</li>
                <li>• Optimización de recorridos</li>
                <li>• Generación de isométricos</li>
              </ul>
            </div>

            <div className="bg-white border border-gray-200 rounded-xl p-6">
              <h4 className="font-semibold text-gray-900 mb-3 flex items-center space-x-2">
                <i className="ri-alarm-warning-line text-emerald-600 text-xl"></i>
                <span>Detección y Alarma</span>
              </h4>
              <ul className="text-gray-700 space-y-2 text-sm">
                <li>• Ubicación óptima de detectores</li>
                <li>• Cálculo de cobertura de detección</li>
                <li>• Diseño de cableado y centralitas</li>
                <li>• Zonificación automática</li>
              </ul>
            </div>

            <div className="bg-white border border-gray-200 rounded-xl p-6">
              <h4 className="font-semibold text-gray-900 mb-3 flex items-center space-x-2">
                <i className="ri-door-open-line text-emerald-600 text-xl"></i>
                <span>Evacuación y Señalización</span>
              </h4>
              <ul className="text-gray-700 space-y-2 text-sm">
                <li>• Análisis de recorridos de evacuación</li>
                <li>• Simulación de flujos de personas</li>
                <li>• Ubicación de señalización</li>
                <li>• Verificación de anchos de paso</li>
              </ul>
            </div>

            <div className="bg-white border border-gray-200 rounded-xl p-6">
              <h4 className="font-semibold text-gray-900 mb-3 flex items-center space-x-2">
                <i className="ri-building-line text-emerald-600 text-xl"></i>
                <span>Sectorización</span>
              </h4>
              <ul className="text-gray-700 space-y-2 text-sm">
                <li>• Definición de sectores de incendio</li>
                <li>• Verificación de superficies máximas</li>
                <li>• Control de elementos de compartimentación</li>
                <li>• Gestión de pasos de instalaciones</li>
              </ul>
            </div>
          </div>

          <h2 className="text-3xl font-bold text-gray-900 mt-12 mb-6">Software BIM para Protección contra Incendios</h2>
          <div className="overflow-x-auto mb-8">
            <table className="w-full bg-white border border-gray-200 rounded-xl">
              <thead className="bg-gray-50">
                <tr>
                  <th className="px-6 py-4 text-left text-gray-900 font-semibold">Software</th>
                  <th className="px-6 py-4 text-left text-gray-900 font-semibold">Especialidad</th>
                  <th className="px-6 py-4 text-left text-gray-900 font-semibold">Características</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-200">
                <tr>
                  <td className="px-6 py-4 text-gray-700 font-medium">Revit MEP</td>
                  <td className="px-6 py-4 text-gray-600">General</td>
                  <td className="px-6 py-4 text-gray-600">Modelado completo de instalaciones</td>
                </tr>
                <tr>
                  <td className="px-6 py-4 text-gray-700 font-medium">Navisworks</td>
                  <td className="px-6 py-4 text-gray-600">Coordinación</td>
                  <td className="px-6 py-4 text-gray-600">Detección de colisiones</td>
                </tr>
                <tr>
                  <td className="px-6 py-4 text-gray-700 font-medium">Pathfinder</td>
                  <td className="px-6 py-4 text-gray-600">Evacuación</td>
                  <td className="px-6 py-4 text-gray-600">Simulación de evacuación</td>
                </tr>
                <tr>
                  <td className="px-6 py-4 text-gray-700 font-medium">PyroSim</td>
                  <td className="px-6 py-4 text-gray-600">Simulación</td>
                  <td className="px-6 py-4 text-gray-600">Análisis de incendios</td>
                </tr>
              </tbody>
            </table>
          </div>

          <h2 className="text-3xl font-bold text-gray-900 mt-12 mb-6">BIM en Mantenimiento y Operación</h2>
          <p className="text-gray-700 leading-relaxed mb-4">
            El modelo BIM continúa siendo útil durante la vida del edificio:
          </p>
          <ul className="list-disc pl-6 mb-6 text-gray-700 space-y-2">
            <li><strong>As-Built digital:</strong> Documentación precisa de lo construido</li>
            <li><strong>Gestión de mantenimientos:</strong> Planificación y registro de revisiones</li>
            <li><strong>Gestión de activos:</strong> Inventario completo de equipos</li>
            <li><strong>Formación:</strong> Recorridos virtuales para personal de emergencias</li>
            <li><strong>Modificaciones:</strong> Base para futuras reformas o ampliaciones</li>
          </ul>

          <h2 className="text-3xl font-bold text-gray-900 mt-12 mb-6">Implementación de BIM en tu Proyecto</h2>
          <div className="bg-white border border-gray-200 rounded-xl p-6 mb-8">
            <h4 className="font-semibold text-gray-900 mb-4">Pasos para Adoptar BIM</h4>
            <ol className="list-decimal pl-6 text-gray-700 space-y-3">
              <li><strong>Evaluación inicial:</strong> Análisis de necesidades y capacidades actuales</li>
              <li><strong>Formación del equipo:</strong> Capacitación en software y metodología BIM</li>
              <li><strong>Definición de estándares:</strong> Establecer protocolos de trabajo</li>
              <li><strong>Proyecto piloto:</strong> Implementación en un proyecto de prueba</li>
              <li><strong>Mejora continua:</strong> Optimización basada en experiencia</li>
            </ol>
          </div>

          <h2 className="text-3xl font-bold text-gray-900 mt-12 mb-6">Retos y Consideraciones</h2>
          <p className="text-gray-700 leading-relaxed mb-4">
            La implementación de BIM presenta algunos desafíos:
          </p>
          <ul className="list-disc pl-6 mb-6 text-gray-700 space-y-2">
            <li>Inversión inicial en software y formación</li>
            <li>Cambio cultural en la organización</li>
            <li>Necesidad de colaboración entre todos los agentes</li>
            <li>Actualización constante de conocimientos</li>
          </ul>

          <h2 className="text-3xl font-bold text-gray-900 mt-12 mb-6">Futuro de BIM en PCI</h2>
          <p className="text-gray-700 leading-relaxed mb-4">
            Las tendencias futuras incluyen:
          </p>
          <ul className="list-disc pl-6 mb-6 text-gray-700 space-y-2">
            <li>Integración con IoT y sensores en tiempo real</li>
            <li>Realidad aumentada para mantenimiento</li>
            <li>Gemelos digitales para gestión operativa</li>
            <li>Inteligencia artificial para optimización de diseños</li>
          </ul>

          {/* CTA Box */}
          <div className="bg-gradient-to-r from-emerald-500 to-teal-600 rounded-2xl p-8 text-white mt-12">
            <h3 className="text-2xl font-bold mb-4">¿Quieres implementar BIM en tus proyectos?</h3>
            <p className="mb-6 text-emerald-50">
              Te ayudamos a integrar la metodología BIM en tus proyectos de protección contra incendios.
            </p>
            <div className="flex flex-col sm:flex-row gap-4">
              <a 
                href="/citas"
                className="bg-white text-emerald-600 px-6 py-3 rounded-lg font-semibold hover:bg-emerald-50 transition-all text-center whitespace-nowrap"
              >
                Solicitar Consultoría
              </a>
              <a 
                href="/#contacto"
                className="bg-emerald-700 text-white px-6 py-3 rounded-lg font-semibold hover:bg-emerald-800 transition-all text-center whitespace-nowrap"
              >
                Más Información
              </a>
            </div>
          </div>
        </div>

        {/* Back to Blog */}
        <div className="mt-12 pt-8 border-t border-gray-200">
          <a 
            href="/blog"
            className="inline-flex items-center space-x-2 text-emerald-600 font-semibold hover:text-emerald-700 transition-colors"
          >
            <i className="ri-arrow-left-line"></i>
            <span>Volver al Blog</span>
          </a>
        </div>
      </article>
    </div>
  );
}